import React from "react"
import {useIntlEx} from "./IntlUtils";
import {PageDialogSidePanel} from "./PageDialog";
import getLogger from "./Logging.js"
import {AppCopyrightNotice, AppLogo} from "./FormComps";
import {useSolv} from "./SolvProvider";

const log = getLogger("PageDialogComps")

export function PageDialogHeader(props) {
  return (
    <>
      <AppLogo size="md" height="40"/>
    </>
  )
}

export function PageDialogFooter(props) {
  const {env} = useSolv()
  const {intl} = useIntlEx()
  return (
    <>
      <div>
        <AppCopyrightNotice/>
      </div>
      {/*<div className="d-flex ml-auto">*/}
      {/*  <a className="text-link ml-2 mr-2" href={env.WWW_URL} title="SOLV Home" target="_blank">www</a>*/}
      {/*  {*/}
      {/*    env.LEGAL_URL &&*/}
      {/*      <a className="text-link mr-2" href={env.LEGAL_URL} title="SOLV Policies" target="_blank">legal</a>*/}
      {/*  }*/}
      {/*  {*/}
      {/*    env.HELP_URL &&*/}
      {/*      <a className="text-link" href={env.HELP_URL} title="Help" target="_blank">{intl.msg("help").toLowerCase()}</a>*/}
      {/*  }*/}

      {/*</div>*/}
    </>
  )
}

export function PageDialogSider(props) {
  const {env} = useSolv()
  const {intl} = useIntlEx()
  return (
    <PageDialogSidePanel {...props}>
      <div className="d-flex flex-column h-100">
        <div className="d-flex justify-content-center w-100 mb-auto">
          <AppLogo size="md" width="120"/>
        </div>
        {
          env.slogan &&
            <div className="mt-3 mb-2" style={{fontWeight: "900"}}>
              {env.slogan}
            </div>
        }
        {
          env.descriptor &&
          <div>
            {env.descriptor}
          </div>
        }
      </div>
    </PageDialogSidePanel>
  )
}

